import { render, staticRenderFns } from "./CoverageCriteriaOptionsSelection.vue?vue&type=template&id=0806c899&scoped=true&"
import script from "./CoverageCriteriaOptionsSelection.vue?vue&type=script&lang=js&"
export * from "./CoverageCriteriaOptionsSelection.vue?vue&type=script&lang=js&"
import style0 from "./CoverageCriteriaOptionsSelection.vue?vue&type=style&index=0&id=0806c899&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0806c899",
  null
  
)

export default component.exports